import type { ReactNode } from 'react';

interface EmptyStateProps {
  icone?: string;
  titulo: string;
  descricao?: string;
  acao?: ReactNode;
  className?: string;
}

// Estado vazio: ícone de linha discreto (sem bolinha colorida), frase e um
// próximo passo opcional.
export default function EmptyState({
  icone = 'ri-inbox-2-line',
  titulo,
  descricao,
  acao,
  className = '',
}: EmptyStateProps) {
  return (
    <div
      className={`flex flex-col items-center justify-center rounded-[18px] bg-background-50 px-6 py-12 text-center shadow-pcard ${className}`}
    >
      <span className="flex h-12 w-12 items-center justify-center text-foreground-300">
        <i className={`${icone} text-[40px]`} aria-hidden />
      </span>
      <p className="mt-3 text-[15px] font-bold text-foreground-950">{titulo}</p>
      {descricao && <p className="mt-1 max-w-sm text-[14px] text-foreground-600">{descricao}</p>}
      {acao && <div className="mt-5">{acao}</div>}
    </div>
  );
}